module.exports = __webpack_public_path__ + "static/media/calendar.34e94624.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar.svg
// module id = 566
// module chunks = 0